export const msalConfig = {
    auth: {
        clientId: "82ba1170-03da-46d4-be4b-dcc3fb4473f1",
        authority: "https://login.microsoftonline.com/33b1ca7f-20ff-4f96-8e27-74acdd92e4bf",
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    }
};

export const loginRequest = {
 //  scopes: ["openid", "profile", "User.Read"]
    scopes: ["api://82ba1170-03da-46d4-be4b-dcc3fb4473f1/access_as_user"]
};
